import { createSlice } from "@reduxjs/toolkit";
import { showPayslip } from "../actions";

const initialState = {
  payslip: [],
};

const payslipSlice = createSlice({
  name: "payslip",
  initialState,
  reducers: {},
  extraReducers: {
    [showPayslip.fulfilled]: (state, action) => {
      state.payslip = action.payload || [];
    },
  },
});

export const responsePayslip = (state) => state.payslip;

export default payslipSlice.reducer;
